import { ISelectedRoom, IPaidService } from 'interfaces'

function getTotalPrice(selectedRooms: ISelectedRoom[], selectedServices: IPaidService[], numDays: number = 1) {
  return (
    selectedRooms.reduce((prevSum, sr) => prevSum + sr.value * sr.room.prezzo, 0) * numDays + //prezzo delle camere selezionate * il numero di giorni
    selectedServices.reduce((prevSum, ss) => prevSum + ss.prezzo, 0)
  ) // prezzo dei servizi scelti
}

export const numberService = {
  getTotalPrice,
}
